import { render, staticRenderFns } from "./AddFeedback.vue?vue&type=template&id=e88efc58&scoped=true"
import script from "./AddFeedback.vue?vue&type=script&lang=js"
export * from "./AddFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88efc58",
  null
  
)

export default component.exports